<template>
  <!-- 下载次数上限-提示 -->
  <van-overlay :show="show">
    <div class="wrapper">
      <div class="content">您今日{{orderStatusText}}下载的数量已达上限，如有更多需求，请联系工作人员。方案热线：<a href="tel:18621280619">18621280619</a>（同微信）<br /> 友情提示：方案仅供个人学习使用，不得用于任何商业用途。</div>
      <div class="footer">
        <button  @click.stop="show = false">确定</button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'download_limit',
  data () {
    return {
      show: false,
      orderStatusText: null
    }
  }
}
</script>

<style lang="scss" scoped>
.van-overlay{
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper{
    background-color: #fff;
    margin: 0 15px;
    border-radius: 8px;
    .content{
      padding: 10px 15px;
      border-bottom: 1px solid #eeeeee;
      color: #646566;
      a{
        color: #0000EE;
        text-decoration: underline;
      }
    }
    .footer{
      button{
        width: 100%;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        font-size: 14px;
        border: none;
        outline: none;
        color: #1989fa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/template/download_limit.vue